<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
  <div class="card">
    <div class="card-header">
      <button class="btn btn-light collapse-toggle btn-sm" data-toggle="collapse" data-target="#income-content-collapse"
        aria-expanded="true" aria-controls="income-content-collapse">
        <span class="collapse-icon"></span>
      </button>Income
      <div class="text-right">
        <button type="button" class="btn btn-sm btn-primary" data-toggle="modal" data-target="#income" (click)="reset()"
          title="Add" [disabled]="contactId == 0">Add
        </button>
      </div>
    </div>
    <div class="collapse show" id="income-content-collapse">
      <div class="card-body">
        @if (incomes.length > 0) {
          <table class="table table-sm table-hover table-striped table-responsive-sm">
            <thead>
              <tr class="text-nowrap">
                <th>Type</th>
                <th>Amount</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (income of incomes; track income; let i = $index) {
                <tr>
                  <td>{{ income.type }}</td>
                  <td>{{ viewAmount ? "$" + income.value : "*********" }}</td>
                  <td>
                    <button class="btn btn-sm text-dark" (click)="viewAmount = !viewAmount" title="View">
                      @if (!viewAmount) {
                        <span>View Amount</span>
                      }
                      @if (viewAmount) {
                        <span>Hide Amount</span>
                      }
                    </button>
                    <button class="btn btn-sm text-dark" (click)="selectIncome(income,'update')" data-toggle="modal"
                      title="Edit" data-target="#updateIncomeModal">
                      Edit
                    </button>
                    <button class="btn btn-sm text-danger" data-toggle="modal" title="Delete"
                      data-target="#deleteIncomeModal" (click)="selectIncome(income,'delete')">
                      Delete
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
      <div class="card-footer">
        <p>Total Income: {{totalIncome | currency}}</p>
      </div>
    </div>
  </div>
</div>

<!-- modals -->
<div id="income" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="standard-modalLabel">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h4 class="modal-title" id="standard-modalLabel">
          {{ words[language][ 'addIncomeSources' ] }}
        </h4>
        <button type="button" class="close" data-dismiss="modal">
          ×
        </button>
      </div>
      <div class="modal-body">
        <!-- body -->
        <form [formGroup]="form">
          <ng-container formArrayName="sources">
            @for (sourceForm of sources.controls; track sourceForm; let i = $index) {
              <div>
                <div class="row mx-0" [formGroup]="sourceForm">
                  <!-- type select-->
                  <div class="form-group col-md-5 col-sm-11">
                    <label for="firstName"> {{ words[language][ 'type' ] }}</label>
                    <select class="custom-select custom-select mb-1 text-capitalize" id="type-new" formControlName="type">
                      @for (type of types; track type) {
                        <option [value]="type" class="text-capitalize">
                          {{ type }}
                        </option>
                      }
                    </select>
                  </div>
                  <!-- value input -->
                  <div class="form-group col-md-6 col-sm-12">
                    <label for="monthly"> {{ words[language][ 'monthlyAmount' ] }}</label>
                    <input class="form-control" type="text" id="monthly-new" formControlName="value" placeholder="$" />
                  </div>
                  <!-- icons -->
                  <div class="col-sm-1 d-flex align-items-center justify-content-center">
                    <!-- discard -->
                    @if ((sources.length > 1) && !loading) {
                      <span class="dripicons-trash text-danger clickable" (click)="discard(i)"
                      ></span>
                    }
                  </div>
                </div>
              </div>
            }
            <button type="button" class="btn btn-success btn-sm" (click)="addIncomeSourceRow($event)"
            id="addSource">{{words[language].addAnother}}</button>
          </ng-container>
        </form>
        <div class="modal-footer">
          <!-- <div class="col-md-12 d-flex justify-content-end px-3 mt-2"> -->
          <!-- save button -->
          <button class="btn btn-success mr-2" id="btn-save-income" (click)="create()"
            [disabled]="form.invalid || loading">
            @if (loading) {
              <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
            }
            Save
          </button>
          <!-- cancel button -->
          <button class="btn btn-light" id="btn-cancel-income" data-dismiss="modal">
            {{ words[language][ 'cancel' ] }}
          </button>
        <!-- </div> -->
      </div>
    </div>
  </div>
  <!-- /.modal-content -->
</div>
<!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<!-- ! delete modal -->
<div class="modal fade" data-backdrop="static" id="deleteIncomeModal" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="uil-trash-alt text-danger h1"></span>
        <h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
        <span class="text-dark my-3 text-center">{{ words[language][ 'deleteIncomeSources' ] }}</span>

        <button class="btn btn-danger mt-2" (click)="delete()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
          {{ words[language][ 'yes' ] }}
        </button>
        <button type="button" class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="close-delete-modal-income"
         >
          No
        </button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<!-- todo: update modals -->
<div id="updateIncomeModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="standard-modalLabel">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h4 class="modal-title" id="standard-modalLabel">
          {{ words[language][ 'updateIncomeSources' ] }}
        </h4>
        <button type="button" class="close" id="btn-close-income" data-dismiss="modal">
          ×
        </button>
      </div>
      <div class="modal-body">
        <!-- body -->
        <form [formGroup]="modForm" class="d-flex p-2 justify-content-between row mx-0 w-100">
          <!-- type select-->
          <div class="form-group col-md-6 col-sm-12">
            <label for="firstName">{{ words[language][ 'type' ] }}</label>
            <select class="custom-select custom-select mb-1 text-capitalize" id="type-update" formControlName="type">
              @for (type of types; track type) {
                <option [value]="type" class="text-capitalize">
                  {{ type }}
                </option>
              }
            </select>
          </div>
          <!-- value input -->
          <div class="form-group col-md-6 col-sm-12">
            <label for="monthly">{{ words[language][ 'monthlyAmount' ] }}</label>
            <input class="form-control" type="text" id="monthly-update" formControlName="value" placeholder="$" />
            @if (value.invalid && value.dirty) {
              <span class="text-danger">{{ words[language][ 'value' ] }}</span>
            }
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <!-- <div class="col-md-12 d-flex justify-content-end px-3 mt-2"> -->
        <!-- save button -->
        <button class="btn btn-success mr-2" id="btn-save" (click)="modify()" [disabled]="modForm.invalid || loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
          Update
        </button>
        <!-- cancel button -->
        <button class="btn btn-light" id="btn-cancel-income" data-dismiss="modal">
          {{ words[language][ 'cancel' ] }}
        </button>
      <!-- </div> -->
    </div>
  </div>
  <!-- /.modal-content -->
</div>
<!-- /.modal-dialog -->
</div>
<!-- /.modal -->
